<template>
	<card class="ReSearchCardStaffBigRoles" v-if="objStaff" >
		<h3 class="mb-1">{{this.objStaff.lastName}} {{this.objStaff.firstName}} {{this.objStaff.fatherName}}</h3>
		<h4>Настройка ролей и доступов</h4>
		<hr>
		<ReFormPrinter 
			:masFormConfig="masAllFormParamsDopInfo" 
			:objDataFromCardApi="objStaff"
			:objSaveApiMethod="currentApiFormMethodDopInfo"
			:SuccessGo="SuccessGo"/>		
	</card>
</template>

<script>
	// import { TabPane, Tabs } from 'src/components';
	import ReFormPrinter from 'src/our_components/FormPrinter/ReFormPrinter.vue';
	export default {
		name: 'ReSearchCardStaffBigRoles',
		components: {
			ReFormPrinter,
			// TabPane,
			// Tabs
		},
		props: {
			objStaff: Object,
		},
		data () {
			return {
				ver: 2,
				bIsEditMode: false,
				// currentApiFormMethodContacts:{apiMethod:'UPD_CONTACT',apiParam:{obj:'staff' ,flt:{code:this.objStaff.code},uData:[]}},
				// currentApiFormMethodDataParamContacts:'uData',
				// masAllFormParamsContacts: this.currentFormConfigContacts(),
				masAllFormParamsDopInfo: this.currentFormConfigDopInfo(),
				currentApiFormMethodDopInfo:{apiMethod:'UPD_STAFF_ROLE',apiParam:{obj:'staff' ,flt:{code:this.objStaff.code},uData:[]}},
			}
		},
		computed: {
			// strFIO: function(){

			// 	return [this.objStaff.lastName,this.objStaff.firstName,this.objStaff.fatherName].join(' ');
			// },
		},
		methods: {
			// currentFormConfigContacts(){
			// 	//return require('src/conf/staffEditContacts_formConfig.js').super_config;
			// 	this.$GVO.ApiCall('GET_FORM_CONTACT',{obj:'staff',flt:{code:this.$route.params.code}})
			// 		.then((objApi) => {
			// 			//console.log(objApi);
			// 			if(objApi.success){
			// 				this.masAllFormParamsContacts = objApi.config;
			// 			}
			// 		})
			// 		.catch(errorObjApi => console.log(errorObjApi));
			// 	return [];
			// },
			currentFormConfigDopInfo(){
				//return require('src/conf/staffEditDopInfo_formConfig.js').super_config;
				this.$GVO.ApiCall('GET_FORM_EXTRA_DATA_ROLES',{obj:'staff',flt:{code:this.$route.params.code}})
					.then((objApi) => {
						//console.log(objApi);
						if(objApi.success){
							this.masAllFormParamsDopInfo = objApi.config;
						}
					})
					.catch(errorObjApi => console.error(errorObjApi));
				return [];
			},
			SuccessGo(evt){
				this.$router.push({path: this.$GVO.str_replace('/roles','',evt)});
				// document.location.reload();
				/*
				if(this.startObjStaff && this.startObjStaff.theme!=this.objStaff.theme){
					document.location.reload();
				}
				*/
			},
		},
		created(){
			
		},
		/*
		watch:{
			objStaff(newValue,oldValue){
				if(!this.startObjStaff) this.startObjStaff=newValue;
			}
		}
		*/
	}
</script>
<style scoped>
	.ReSearchCardStaffBigRoles hr{
		color:#01B0E0; 
		background-color: #01B0E0; 
		height: 2px;
	}
	.ReSearchCardStaffBigRoles .card-user{
		display: flex;
		flex-direction: row;
		justify-content: space-between;
	}
	.ReSearchCardStaffBigRoles .card-user [slot='header']{
		position: absolute;
		right:0px;
		top:0px;
	}
	.card-user .left_part, .card-user .right_part{
		width: 100%;
		display: flex;
		flex-flow: row nowrap;
	}
	/*.card-user .left_part{}*/
	.card-user .right_part{justify-content: space-between;}
	.card-user .left_part > *, .card-user .right_part > *{display: inline-block; vertical-align: top;}

	.avatarBlk{width:200px;}
	.avatarBlk .avatar{
		object-fit: contain;
		background-color: white;
	}
	
	.onlineStatus{text-align: center;}
	.onlineStatus > *{display: inline-block;}
	.onlineStatus i{
		width: 7px;
		height: 7px;
		border-radius: 50%;
		margin-right: 5px;
	}
	.onlineStatus.online i{background-color: greenyellow;}
	.onlineStatus.offline i{background-color: red;}

	.socialBlk > *{margin-right: 10px;}

	.fioBlk, .contactsBlk, .orgBlk{margin-top: 35px;}

	p.description a > i{ margin-left: 5px;}
	.title{text-transform: uppercase;}

	.dopInfoBlk{
		display: flex;
		flex-direction: row;
		justify-content: space-between;
	}
	.dopInfoBlk > div:nth-child(1){width: 200px;}
	.dopInfoBlk > div:nth-child(2){width: calc(100% - 200px);}
	.dopInfoBlk .dopInfoItem{margin-bottom: 15px;}
	.dopInfoBlk .dopInfoItem h4{margin-bottom: 3px; font-weight: bold;}
	.ReSearchCardStaffBigRoles >>> .elementWrapper > div {border-bottom: 1px dashed #01B0E0; padding-bottom: 10px; margin-left: 5px;}
	
	@media (max-width: 1100px){
		.card-user .orgBlk{display:none;}
		.dopInfoBlk > div:nth-child(1){display: none;}
		.dopInfoBlk > div:nth-child(2){width: 100%;}
	}
	@media (max-width: 600px){
		.ReSearchCardStaffBigRoles .card-user{
			display: block;
		}
		.card-user .left_part, .card-user .right_part{display: block;}
	}
	
</style>
